import TooltipIcon from "./Tooltip";

export const WithTooltip = ({ isNeeded = true, children, ...props }) => {
    if( !isNeeded ){
        return children;
    }

    return (
        <TooltipIcon {...props}>
            {children}
        </TooltipIcon>
    )
};